import { useCallback } from 'react'
import { useQueryClient } from 'react-query'

type useIsServerSideRenderedType = () => () => boolean

const useIsServerSideRendered: useIsServerSideRenderedType = () => {
  const queryClient = useQueryClient()

  const isServerSideRendered = useCallback(
    () => !!queryClient.getQueryData<boolean>('isServerRendered'),
    [queryClient]
  )

  return isServerSideRendered
}

export default useIsServerSideRendered
